import React from "react";

export default function renderWithRootFragment(data) {
  //Map the fragment internals to query to allow for root query fragments
  const { Component, props } = data;
  if (!props) return null;
  const { __fragmentOwner, __fragments, __id, ...others } = props;
  const fragment = { __fragmentOwner, __fragments, __id };
  const fragments = Object.keys(__fragments).reduce((acc, name) => {
    const key = /_(\w*)$/.exec(name)[1];
    acc[key] = fragment;
    return acc;
  }, {});
  const fixProps = {
    ...others,
    ...fragments,
  };
  return <Component {...fixProps} />;
}
